import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/Breadcrumbs";
import { breadcrumbLd } from "@/lib/siteContent";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);
  const crumbs = [{ label: "Home", to: "/" }, { label: "Blog", to: "/blog" }];
  return (
    <div className="ca-container py-12">
      <Seo title="Complaint, Consumer Rights and Dispute Resolution Blog | ComplaintAdvisor"
        description="Read practical guides about complaint documentation, customer and vendor disputes, consumer awareness, government complaint channels, and resolution methods."
        path="/blog" jsonld={breadcrumbLd(crumbs)} />
      <Breadcrumbs items={crumbs} />
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 mt-3">ComplaintAdvisor Blog</h1>
      <p className="text-slate-600 mt-2 max-w-2xl">Practical, general-information guides on documenting disputes, refunds, agreements and fair resolution.</p>
      <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {posts.map((b) => (
          <Link key={b.id} to={`/blog/${b.slug}`} data-testid={`blog-card-${b.slug}`}
            className="rounded-2xl border border-slate-200 bg-white p-6 hover:shadow-md transition-shadow">
            <span className="text-xs font-semibold text-teal">{b.category}</span>
            <h4 className="font-semibold text-slate-900 mt-2">{b.title}</h4>
            <p className="text-sm text-slate-600 mt-2 line-clamp-3">{b.excerpt}</p>
            <p className="text-[11px] text-slate-400 mt-3">{b.date} · {b.author}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
